if ($(".single-projet").length) {
	let options = {
		rootMargin: '0px',
		threshold: 0.25

	};
	let optionsVariant = {
		rootMargin: '-50px',
		threshold: 0.1

	};
	//TECHNOLOGIE
	let Techno = $('.technologie')
	let containerTechno = document.querySelectorAll('.technologie');
	let observerTechno = new IntersectionObserver(function (entries, observer) {
		entries.forEach((entry) => {
			if (!entry.isIntersecting) {
				return;
			}
			Techno.addClass('active')
			Techno.addClass('animate__animated animate__flipInX')

		});
	}, options);
	containerTechno.forEach(containerTechno => observerTechno.observe(containerTechno));

	//VISUEL BIG IMAGE
	let ContentEntry = $('.content-entry')
	let ContentContentEntry = document.querySelectorAll('.content-entry');
	let observerContentEntry = new IntersectionObserver(function (entries, observer) {
		entries.forEach((entry) => {
			if (!entry.isIntersecting) {
				return;
			}
			ContentEntry.addClass('active')
			ContentEntry.addClass('animate__animated animate__fadeInLeft')

		});
	}, optionsVariant);
	ContentContentEntry.forEach(ContentContentEntry => observerContentEntry.observe(ContentContentEntry));

	//VISUEL BIG IMAGE
	let big_img = $('.big_img')
	let containerBigImage = document.querySelectorAll('.big_img');
	let observerBigImage = new IntersectionObserver(function (entries, observer) {
		entries.forEach((entry) => {
			if (!entry.isIntersecting) {
				return;
			}
			big_img.addClass('active')
			big_img.addClass('animate__animated animate__fadeInRight')

		});
	}, options);
	containerBigImage.forEach(containerBigImage => observerBigImage.observe(containerBigImage));


	//VISUEL FIRST IMAGE
	let FirstImage = $('.first-image')
	let containerFirstImage = document.querySelectorAll('.first-image');
	let observerFirstImage = new IntersectionObserver(function (entries, observer) {
		entries.forEach((entry) => {
			if (!entry.isIntersecting) {
				return;
			}
			FirstImage.addClass('active')
            FirstImage.addClass('animate__animated animate__fadeInUp')

		});
	}, options);
	containerFirstImage.forEach(containerFirstImage => observerFirstImage.observe(containerFirstImage));

	//VISUEL FIRST IMAGE
	let SecondImage = $('.second-image')
	let containerSecondImage = document.querySelectorAll('.first-image');
	let observerSecondImage = new IntersectionObserver(function (entries, observer) {
		entries.forEach((entry) => {
			if (!entry.isIntersecting) {
				return;
			}
			SecondImage.addClass('active')
            SecondImage.addClass('animate__animated animate__fadeInDown')

		});
	}, options);
	containerSecondImage.forEach(containerSecondImage => observerSecondImage.observe(containerSecondImage));

	//VISUEL GALLERIE GEN
	let Visuel = $('.visuel')
	let containerVisuel = document.querySelectorAll('.visuel');
	let observerVisuel = new IntersectionObserver(function (entries, observer) {
		entries.forEach((entry) => {

			if (!entry.isIntersecting) {
				return;
			}
			let index = 0;
			let delay = setInterval( function(){
				if ( index <= Visuel.length ){
					$( Visuel[ index ] ).addClass( 'active' );
					$( Visuel[ index ] ).addClass( 'animate__animated animate__fadeInUp' );
					index += 1;
				}else{
					clearInterval( delay );
				}
			}, 150 );

		});
	}, optionsVariant);
	containerVisuel.forEach(containerVisuel => observerVisuel.observe(containerVisuel));
}


